import { Component, OnInit } from '@angular/core';
import { OwlOptions } from 'ngx-owl-carousel-o';
import {DoctorsService} from '../../services/doctors/doctors.service';
import {environment} from '../../../environments/environment';

@Component({
  selector: 'app-home-medici',
  templateUrl: './home-medici.component.html',
  styleUrls: ['./home-medici.component.scss']
})
export class HomeMediciComponent implements OnInit {


    doctors: any;
    endpoint: any;

    constructor(
        private doctorsService: DoctorsService
    ) {
        const t = this;
        t.endpoint = environment.endpoint;
        this.loadItems();
    }

    instructorSlides: OwlOptions = {
    loop: true,
    nav: true,
    dots: false,
    autoplayHoverPause: true,
    autoplay: true,
    margin: 30,
    navText: [
        '<i class=\'bx bx-left-arrow-alt\'></i>',
        '<i class=\'bx bx-right-arrow-alt\'></i>'
    ],
    responsive: {
        0: {
        items: 1
        },
        576: {
        items: 2
        },
        768: {
        items: 2
        },
        960: {
        items: 3
        }
    }
    };


    loadItems() {
        const t = this;
        this.doctorsService.get().subscribe((data: any) => {
            t.doctors = data;
        });
    }

    setFilePath(fileUrl: any) {
        return this.endpoint + 'files/' + fileUrl.photo.path + '/download';
    }


    ngOnInit(): void {
    }

}
